import { Icon } from '~/components';

export function UPCInfo({ externalId }: { externalId: string }) {
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(externalId);
  };

  return (
    <div
      className="flex items-center"
      onClick={(event) => {
        event.stopPropagation();
        handleCopyToClipboard();
      }}
      onKeyDown={(event) => {
        event.stopPropagation();

        if (event.key === 'Enter' || event.key === ' ') {
          handleCopyToClipboard();
        }
      }}
      role="button"
      tabIndex={0}
    >
      {externalId}
      <div className="group flex items-center" style={{ width: '3rem' }}>
        <div className="hidden pl-sm text-subtle hover:text-hover group-hover:block">
          <Icon type="copy" variant="light" size="sm" data-testid="copy-icon" />
        </div>
      </div>
    </div>
  );
}

UPCInfo.displayName = 'UPCInfo';
